import { FC, useState } from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { Button, baseVariables } from '@marriott/mi-ui-library';
import { useMediaQuery } from '../../hooks';
import { ProgressTracker } from '../../molecules';
import { StyledRfpHeader } from './RfpHeader.styles';
import { RfpHeaderProps } from './RfpHeader.types';
import { EventSummaryModal } from './EventSummaryModal';

export const RfpHeaderConfig = {
  emptyLabel: 'RfpHeader',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/rfp/header`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const RfpHeader: FC<{ model: RfpHeaderProps }> = (props: any) => {
  const {
    pageTitle,
    eventProfile,
    eventDetails,
    contactInformation,
    viewEventSummary,
    currentPageNo,
    currentStep,
    eventSummary,
    styleclass,
  } = props.model;

  const isMobile = !useMediaQuery(baseVariables.mediaQuery.md);

  const [showEventSummaryModal, setShowEventSummaryModal] = useState(false);

  const progressTracker = (
    <ProgressTracker steps={[eventProfile, eventDetails, contactInformation]} currentStep={+currentPageNo} />
  );

  return (
    <EditableComponent config={RfpHeaderConfig} {...props}>
      <div className={`fullbleed m-container-fullbleed ${styleclass}`}>
        <StyledRfpHeader data-component-name="o-groups-rpfheader" data-testid="rpfheader" className="container">
          <div className="row py-5">
            {isMobile && <div className="col-12 progress-tracker">{progressTracker}</div>}

            <div className="col-6 col-md-4 col-lg-6 pl-0 pt-2">
              <span className="t-overline-normal">{currentStep.replace('{x}', currentPageNo)}</span>
              <h1 className="t-title-s">{pageTitle}</h1>
            </div>

            {!isMobile && <div className="col-md-5 col-lg-4 progress-tracker">{progressTracker}</div>}

            <div className="col-6 col-md-3 col-lg-2 view-event-summary">
              <Button
                buttonCopy={viewEventSummary}
                className="m-link-action"
                trackingProperties={{ impressionTrack: true }}
                callback={() => setShowEventSummaryModal(true)}
              />
            </div>
          </div>
        </StyledRfpHeader>
        {showEventSummaryModal ? (
          <EventSummaryModal
            labels={{ eventSummary, currentPageNo, currentStep }}
            show={showEventSummaryModal}
            onCloseModal={() => setShowEventSummaryModal(false)}
          />
        ) : null}
      </div>
    </EditableComponent>
  );
};
